var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-chip",class:`c-chip__variant--${_vm.variant} ${
    _vm.size.length > 0 ? `c-chip__variant--${_vm.size}` : ''
  }`,on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }